import { HeaderContext, RowData, flexRender } from '@tanstack/react-table';
import { css, MAGNETIC_TOKENS } from '@appd/uik';

const { TYPOGRAPHY } = MAGNETIC_TOKENS;

// use Tailwind for static styling, use inline style for dynamic styling
const STYLES = {
  HEADER: css.Styles({
    fontFamily: TYPOGRAPHY.P3_BOLD,
  }),
};

export const HeaderCell = <TData extends RowData, TValue>({ header }: HeaderContext<TData, TValue>): JSX.Element => {
  return (
    <th
      className="text-sm bg-inherit border-b-2 border-solid border-control-border-strong"
      style={{
        ...STYLES.HEADER,
        ...{ width: header.column.getSize(), textAlign: header.column.columnDef.meta?.align },
      }}
    >
      <div className="flex-1 content-center bg-inherit">
        {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
      </div>
    </th>
  );
};
